<div [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
  <sbnb-loading-spinner *ngIf="loading$ | async; else content"></sbnb-loading-spinner>
  <ng-template #content>
    <sbnb-alert-card context="warning" *ngIf="noBackupCard" class="mb-3 gap-2 flex-col max-w-[550px]">
      <strong>You don't have a backup card specified.</strong>
      <span>If the primary card fails, you will not be able to make payments.</span>
    </sbnb-alert-card>
    <div
      *ngIf="savedCards.length > 0"
      class="saved__container md:flex md:flex-row flex-col gap-3"
      data-attr="saved-payment-methods">
      <div class="md:w-[280px] mb-3 strong">Saved methods</div>
      <div>
        <ng-container *ngFor="let card of savedCards">
          <div class="payment__saved-container flex items-center gap-3" data-attr="payment-method-item">
            <div class="flex items-center gap-3 flex-1">
              <span *ngIf="card.type === 'card'">
                <ng-template [ngTemplateOutlet]="cardLabel" [ngTemplateOutletContext]="{ card: card }"></ng-template>
                <div class="exp-date">Exp. {{ card.expiry_date }}</div>
              </span>
              <span *ngIf="card.type === 'paypal_express_checkout'">
                <strong>PayPal:</strong>
                {{ card.email }}
              </span>
            </div>
            <span *ngIf="card.primary" class="pill__primary">Primary</span>
            <span *ngIf="card.backup" class="pill__primary pill__backup">Backup</span>
            <a
              *ngIf="
                !card.primary &&
                !card.backup &&
                card.status !== PaymentCardStatus.Expiring &&
                card.status !== PaymentCardStatus.Expired
              "
              (click)="changePaymentMethodRole(card, 'backup')"
              class="link-emphasized text-xs">
              Set as backup
            </a>
            <mat-spinner *ngIf="card.actioning" [diameter]="16"></mat-spinner>
            <sbnb-more-menu-trigger
              [matMenuTriggerFor]="actionsMenu"
              *ngIf="
                (!card.actioning && savedCards.length > 1) || (!card.actioning && canDeleteLastPaymentMethod)
              "></sbnb-more-menu-trigger>
            <mat-menu #actionsMenu="matMenu">
              <button mat-menu-item *ngIf="!card.primary" (click)="changePaymentMethodRole(card, 'primary')">
                <span>
                  <mat-icon inline="true">event_note</mat-icon>
                  <span>Set as primary</span>
                </span>
              </button>

              <button
                *ngIf="!card.backup && !card.primary"
                mat-menu-item
                (click)="changePaymentMethodRole(card, 'backup')">
                <span>
                  <mat-icon inline="true">event_note</mat-icon>
                  <span>Set as backup</span>
                </span>
              </button>

              <button mat-menu-item (click)="$event.preventDefault(); $event.stopPropagation(); deleteCard(card)">
                <span>
                  <mat-icon inline="true">event_note</mat-icon>
                  <span>Delete</span>
                </span>
              </button>
            </mat-menu>
          </div>
          <sbnb-alert-card
            context="warning"
            *ngIf="card.status === PaymentCardStatus.Expiring"
            class="night text__large gap-1">
            <ng-template [ngTemplateOutlet]="cardLabel" [ngTemplateOutletContext]="{ card: card }"></ng-template>
            <strong>expires soon</strong>
          </sbnb-alert-card>
          <sbnb-alert-card
            context="negative"
            *ngIf="card.status === PaymentCardStatus.Expired"
            class="night text__large gap-1">
            <ng-template [ngTemplateOutlet]="cardLabel" [ngTemplateOutletContext]="{ card: card }"></ng-template>
            <strong>is expired</strong>
          </sbnb-alert-card>
        </ng-container>
      </div>
    </div>

    <div class="md:flex md:flex-row flex-col gap-3" data-attr="add-payment-card-section">
      <div class="md:w-[280px] mb-3 strong">Add a payment card</div>
      <div class="md:flex md:flex-row flex-col md:gap-2 gap-3">
        <div class="chargebee__container">
          <div cbCardField id="card-field" (ready)="onReady($event)" (change)="onChange($event)"></div>
          <div *ngIf="error" class="paymentcard-error">
            {{ error }}
          </div>
        </div>

        <button
          [disabled]="saving || !addCardSaveEnabled"
          mat-flat-button
          class="button__small button__add"
          data-attr="save-payment-card-button"
          (click)="saveChangesClicked()">
          <span>{{ embedded ? 'Add & continue' : 'Save' }}</span>
          <mat-spinner *ngIf="saving" class="button__spinner" [diameter]="16"></mat-spinner>
        </button>
      </div>
    </div>

    <div class="paypal__container items-center md:flex md:flex-row flex-col gap-3" data-attr="add-paypal-section">
      <div class="md:w-[280px] mb-3 strong">Add a PayPal account</div>
      <sbnb-alert-card *ngIf="unsupportedCurrency">Paypal is not supported in your currency.</sbnb-alert-card>
      <div id="paypal-button"></div>
    </div>

    <div *ngIf="embedded" class="embedded__continue flex flex-col gap-3" data-attr="embedded-continue-section">
      <div
        class="flex gap-2 items-center flex-1 max-w-[550px] min-w-[250px]"
        *ngIf="currentSubscription$ | async as currentSubscription">
        <sbnb-icon icon="details" [size]="16" class="text-night-lighter"></sbnb-icon>
        <span
          class="night-lighter text__small"
          matTooltip="Your bank may notify you to authorize upcoming charges to verify the transaction. Your payment method will only be charged on your billing date."
          matTooltipPosition="right">
          Bank verification may be required
        </span>
      </div>
      <div>
        <button
          *ngIf="primaryCard"
          [disabled]="primaryCard.status === PaymentCardStatus.Expired"
          [matTooltip]="primaryCard.status === PaymentCardStatus.Expired ? 'Add a valid card to continue' : null"
          mat-flat-button
          class="button__primary"
          data-attr="continue-with-payment-button"
          (click)="continue()">
          <span *ngIf="primaryCard?.type === 'paypal_express_checkout'">
            Continue with Paypal: {{ primaryCard?.email }}
          </span>
          <span *ngIf="primaryCard?.type === 'card'">
            Continue with
            <ng-template [ngTemplateOutlet]="cardLabel" [ngTemplateOutletContext]="{ card: primaryCard }"></ng-template>
          </span>
        </button>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #cardLabel let-card="card">
  <strong>{{ card.brand }}</strong>
  ending in {{ card.last4 }}
</ng-template>
